/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 03/06/2023.
 */
import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { useHover } from '@use-gesture/react'

import { useScaleUp } from '../../animation/useFadeIn'
import FadeUp from '../../animation/FadeUp'

const KitchenTemplateGallery = ({ gallery, product }) => {
  const imageOne = getImage(gallery[0])
  const imageTwo = getImage(gallery[1])
  const imageBig = getImage(gallery[2])

  if (!imageOne || !imageTwo || !imageBig) {
    console.log('KitchenTemplateGallery > MISSING IMAGE = ')
  }

  return (
    <div className="row" style={{}}>
      <FadeUp yposOffSet={50} className="col-12 col-md-6 px-2 mb-2" style={{}}>
        <div className="overflow-hidden">
          <AniImageContain image={imageOne}></AniImageContain>
        </div>
        {/*<p className="p-small ps-2  mt-1">{product.name || ''} i valnød finér</p>*/}
      </FadeUp>

      <FadeUp delay={200} yposOffSet={50} className="col-12 col-md-6 px-2 mb-2">
        <div className="overflow-hidden">
          <AniImageContain image={imageTwo}></AniImageContain>
        </div>

        {/*<p className="p-small mt-1 ps-2 ">{product.name || ''} i blå linolium</p>*/}
      </FadeUp>

      <FadeUp className="d-block d-md-none col-12 mt-md-4 mt-2 " style={{}}>
        <div className="overflow-hidden">
          <AniImageContain image={imageBig}></AniImageContain>
        </div>
      </FadeUp>

      <FadeUp className="d-none d-md-block col-12 mt-md-4 mt-2 " style={{}}>
        <div className="overflow-hidden">
          <AniImageCover image={imageBig}></AniImageCover>
        </div>
      </FadeUp>
    </div>
  )
}

const AniImageContain = ({ image }) => {
  const { animated, spring, hover, out } = useScaleUp()

  const bind = useHover(({ active }) => {
    if (active) {
      hover()
    } else {
      out()
    }
  })

  return (
    <animated.div {...bind()} style={spring}>
      <GatsbyImage className="rounded-1 " image={image} alt={'asdasd'} imgStyle={{ objectFit: 'contain' }} />
    </animated.div>
  )
}

const AniImageCover = ({ image }) => {
  const { animated, spring, hover, out } = useScaleUp()

  const bind = useHover(({ active }) => {
    if (active) {
      hover()
    } else {
      out()
    }
  })

  return (
    <animated.div {...bind()} style={spring}>
      <GatsbyImage
        className="rounded-1 ratio ratio-16x9 "
        image={image}
        alt={'asdasd'}
        imgStyle={{ objectFit: 'cover' }}
      />
    </animated.div>
  )
}

export default KitchenTemplateGallery
